import React from 'react';
import { Link } from 'react-router-dom';
import styles from './HomeReleasesPanel.module.css';
import Pill from '../common/Pill';
import Ico from '../common/Ico';
import { timeSinceTS } from '../../helpers/dates';

const ICO_ROCKET = 'M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09zM12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z';

export default function HomeReleasesPanel({ releases = [] }) {
  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <Ico d={ICO_ROCKET} size={14} style={{ color: 'var(--fg-muted)' }} />
        Releases
      </div>
      <div className={styles.list}>
        {releases.map((r) => {
          const parent = r.branch_version || r.source_branch;
          return (
            <Link key={r.version} to={`/releases/${r.version}`} className={styles.row}>
              <span className={styles.version}>{r.version}</span>
              {r.is_latest && <Pill kind="info">LATEST</Pill>}
              {!r.is_latest && r.to_release && <Pill kind="ok">TO RELEASE</Pill>}
              <span className={styles.meta}>
                {parent && `from ${parent}`}
                {r.status === 'released' && r.release_date ? ` · ${timeSinceTS(r.release_date)}` : ''}
              </span>
            </Link>
          );
        })}
      </div>
      <Link to="/releases" className={styles.footer}>View all releases</Link>
    </div>
  );
}
